// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Testimonials */
.testimonialContainer {
  display: flex;
  max-width: 1690px; /* Set a maximum width for larger screens */
  margin-left: auto;
  margin-right: auto;
  padding: 80px 13.103%;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  background: #FFF;
}

.testimonialTitle {
  color: #101010;
  text-align: center;
  font-family: "General Sans";
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.64px;
}

.titleHighlight {
  color: #FF2459;
}

.tweetContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 24px;
}

.testimonialCardContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 0 0 calc(33.33% - 20px);
  padding: 36px 26px;
  gap: 20px;
  border-radius: 16px;
  border: 1px solid var(--Date-Stroke, #F0F0F0);
  background: var(--White, #FFF);
  box-shadow: 0px 0.789px 1.579px 0px rgba(16, 24, 40, 0.05);
}

.testimonialHeader {
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}

.Tdp {
  width: 48px;
  height: 48px;
  border-radius: 48px;
  background: lightgray 0px -6.06px/100.03% 140.186% no-repeat;
}

.TuserDetails {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.Tusername {
  color: #101010;
  font-family: "General Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.395px;
}

.TuserId {
  color: #717171;
  font-family: "General Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.395px;
}

.tweet {
  align-self: stretch;
  color: #101010;
  font-family: "General Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 28.8px */
  letter-spacing: -0.4px;
}

@media screen and (max-width: 650px) {
  .testimonialContainer {
    padding: 40px 24px;
    gap: 36px;
    max-width: 100vw !important;
  }
  .testimonialCardContainer {
    align-self: normal;
    flex: 0 0 327px;
    padding: 20px;
    margin-bottom: 20px;
  }
  .testimonialTitle {
    color: var(--Black, #101010);
    font-family: "General Sans";
    font-size: 24px;
    font-style: normal;
    align-self: baseline;
    font-weight: 600;
    line-height: 150%; /* 28.8px */
    text-align: start;
  }
  .tweetContainer {
    width: 100vw;
    gap: 12px;
    padding-left: 24px;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }
  .tweetContainer::-webkit-scrollbar {
    width: 64px;
    height: 8px;
  }
  .tweetContainer::-webkit-scrollbar-track {
    background-color: #dbd4d4;
    margin: 155.5px;
    border-radius: 10px;
  }
  .tweetContainer::-webkit-scrollbar-thumb {
    background-color: #101010;
    border-radius: 10px;
    width: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/landing-page/components/testimonial/style.scss"],"names":[],"mappings":"AAAA,iBAAA;AAEA;EACI,aAAA;EACA,iBAAA,EAAA,2CAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAAJ;;AAGE;EACE,cAAA;AAAJ;;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,6CAAA;EACA,8BAAA;EACA,0DAAA;AAAJ;;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4DAAA;AAAJ;;AAGE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;;AAGE;EACE,cAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAAJ;;AAGE;EACE,cAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAAJ;;AAGE;EACE,mBAAA;EACA,cAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,sBAAA;AAAJ;;AAGE;EAEE;IACE,kBAAA;IACA,SAAA;IACA,2BAAA;EADJ;EAIE;IACE,kBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;EAFJ;EAKE;IACE,4BAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,oBAAA;IACA,gBAAA;IACA,iBAAA,EAAA,WAAA;IACA,iBAAA;EAHJ;EAME;IACE,YAAA;IACA,SAAA;IACA,kBAAA;IACA,2BAAA;IACA,iBAAA;IACA,gBAAA;IACA,uBAAA;IACA,iCAAA;EAJJ;EAOE;IACE,WAAA;IACA,WAAA;EALJ;EAQE;IACE,yBAAA;IACA,eAAA;IACA,mBAAA;EANJ;EASE;IACE,yBAAA;IACA,mBAAA;IACA,WAAA;EAPJ;AACF","sourcesContent":["/* Testimonials */\n\n.testimonialContainer{\n    display: flex;\n    max-width: 1690px; /* Set a maximum width for larger screens */\n    margin-left: auto;\n    margin-right: auto;\n    padding:80px 13.103%;\n    box-sizing: border-box;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 48px;\n    background:#FFF;\n  }\n  \n  .testimonialTitle{\n    color:#101010;\n    text-align: center;\n    font-family: \"General Sans\";\n    font-size: 48px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%; \n    letter-spacing: -0.64px;\n  }\n  \n  .titleHighlight{\n    color:#FF2459;\n  }\n  \n  .tweetContainer{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 24px;\n  }\n\n.testimonialCardContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex: 0 0 calc(33.33% - 20px);\n    padding: 36px 26px;\n    gap: 20px;\n    border-radius: 16px;\n    border: 1px solid var(--Date-Stroke, #F0F0F0);\n    background: var(--White, #FFF);\n    box-shadow: 0px 0.789px 1.579px 0px rgba(16, 24, 40, 0.05);\n  }\n  \n  .testimonialHeader{\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    align-self: stretch;\n  }\n  \n  .Tdp{\n    width: 48px;\n    height: 48px;\n    border-radius: 48px;\n    background: lightgray 0px -6.06px / 100.03% 140.186% no-repeat;\n  }\n  \n  .TuserDetails{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .Tusername{\n    color: #101010;\n    font-family: \"General Sans\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: -0.395px;\n  }\n  \n  .TuserId{\n    color:  #717171;\n    font-family: \"General Sans\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    letter-spacing: -0.395px;\n  }\n  \n  .tweet{\n    align-self: stretch;\n    color:  #101010;\n    font-family: \"General Sans\";\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 160%; /* 28.8px */\n    letter-spacing: -0.4px;\n  }\n  \n  @media screen and (max-width: 650px)  {\n\n    .testimonialContainer{\n      padding: 40px 24px;\n      gap: 36px;\n      max-width: 100vw !important;\n    }\n  \n    .testimonialCardContainer {\n      align-self:normal;\n      flex: 0 0 327px;\n      padding: 20px;\n      margin-bottom: 20px;\n    }\n  \n    .testimonialTitle{\n      color: var(--Black, #101010);\n      font-family: \"General Sans\";\n      font-size: 24px;\n      font-style: normal;\n      align-self: baseline;\n      font-weight: 600;\n      line-height: 150%; /* 28.8px */\n      text-align: start;\n    }\n    \n    .tweetContainer{\n      width: 100vw;\n      gap:12px;\n      padding-left: 24px;\n      justify-content: flex-start;\n      flex-wrap: nowrap;\n      overflow-x: auto;\n      scroll-behavior: smooth;\n      -webkit-overflow-scrolling: touch;\n    }\n  \n    .tweetContainer::-webkit-scrollbar {\n      width: 64px;\n      height: 8px;\n    }\n  \n    .tweetContainer::-webkit-scrollbar-track {\n      background-color: #dbd4d4; \n      margin: 155.5px;\n      border-radius: 10px;\n    }\n  \n    .tweetContainer::-webkit-scrollbar-thumb {\n      background-color: #101010; \n      border-radius: 10px;\n      width: 10px;\n    }\n  \n    \n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
